<template>
    <div>
        <!-- <b-modal
            :active.sync="showDeleteModal"
            :can-cancel="['escape', 'outside']"
            trap-focus
            class="has-text-centered"
        >
            <div class="modal-body">
                <span
                    class="is-size-4 has-text-danger has-text-weight-bold is-uppercase"
                >
                    {{ $t("manageAccount.deleteaccForm.confirm") }}
                </span>
                <ValidationObserver v-slot="{ handleSubmit, invalid }">
                    <form
                        class="form"
                        @submit.prevent="handleSubmit(console.log('?'))"
                    >
                        <div
                            class="is-size-6 mb-2 has-text-weight-bold"
                        >
                            {{ $t("manageAccount.deleteaccForm.description") }}
                        </div>

                        <div class="field is-grouped">
                            <div class="control">
                                <button
                                    :disabled="invalid"
                                    class="is-uppercase is-size-6 primary-btn is-danger"
                                    type="submit"
                                >
                                    <span class="m-0 p-0">
                                        {{
                                            $t(
                                                "manageAccount.deleteaccForm.submit"
                                            )
                                        }}</span
                                    >
                                </button>

                                <button
                                    :disabled="invalid"
                                    class="is-uppercase is-size-6 primary-btn"
                                    type="reset"
                                    @click.prevent="showDeleteModal = false"
                                >
                                    <span class="m-0 p-0">
                                        {{
                                            $t(
                                                "manageAccount.deleteaccForm.cancel"
                                            )
                                        }}</span
                                    >
                                </button>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </b-modal> -->

        <div class="gradient-overlay"></div>
        <section v-if="loggedUser" class="main-content">
            <GridBox>
                <GridItem
                    size="100%"
                    :colidx="3"
                    class="p-5 height-auto"
                    glassy
                >
                    <GridBody class="m-0">
                        <div
                            class="is-size-3 has-text-primary-alt has-text-weight-bold mb-2"
                        >
                            {{
                                this.$store.getters["public-auth/authedUser"]
                                    .firstName
                            }}
                            {{
                                this.$store.getters["public-auth/authedUser"]
                                    .lastName
                            }}
                        </div>

                        <div
                            class="is-size-6 has-text-primary has-text-weight-bold"
                        >
                            {{
                                this.$store.getters["public-auth/authedUser"]
                                    .email
                            }}
                        </div>
                    </GridBody>
                </GridItem>
                <GridItem size="100%" :colidx="1" class="p-5" glassy>
                    <GridBody class="m-0 stretch">
                        <div class="is-size-3 is-subtle has-text-weight-bold">
                            {{ $t("manageAccount.changepwdform.title") }}
                        </div>
                        <AuthedPwChange />
                    </GridBody>
                </GridItem>
                <GridItem size="100%" :colidx="1" class="p-5" glassy>
                    <GridBody class="m-0">
                        <div class="is-size-3 is-subtle has-text-weight-bold">
                            {{ $t("manageAccount.deleteaccForm.title") }}
                        </div>

                        <button
                            class="is-uppercase is-size-6 primary-btn is-danger"
                            disabled
                            @click.prevent="showDeleteModal = true"
                        >
                            <span class="m-0 p-0">
                                {{
                                    $t("manageAccount.deleteaccForm.submit")
                                }}</span
                            >
                        </button>
                    </GridBody>
                </GridItem>
            </GridBox>
        </section>
    </div>
</template>

<style lang="scss" scoped>
.stretch {
    align-items: stretch !important;
}
.gradient-overlay {
    transition: all 0.2s ease-in-out;
    opacity: 0.5;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    width: 100%;
    overflow: hidden;
    height: 90vh;
    width: 100%;
    background: linear-gradient(
        180deg,
        rgba(var(--color-primary-alt-rgba), 0.25) 0%,
        rgba(var(--color-primary-alt-rgba), 0) 100%
    );
    /* background: red; */
}
.main-content {
    /* padding-bottom: 5rem; */
    max-width: 1280px;
    height: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    /* margin-bottom: 2rem; */
    padding: 1rem;
}
.modal-body {
    @media screen and (max-width: 768px) {
        width: 90vw;
    }
    background: rgba(var(--bg-rgba), 0.8);
    backdrop-filter: blur(2rem);
    border-radius: var(--radius-sm);
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: auto;
    max-width: 450px;
    text-align: left;
}
</style>
<script>
const CHECK_USER = `
    query check {
        authenticatedPublicUtente {
            id
            email
            firstName
            lastName
            active
            memberships {
                id
                nationalId
                fiscalCode
                dob
                address
                createdAt
                acceptsMarketing
                expires
                citizenship
                city
                country
                type {
				    name
                    nameEn
			    }
            }
        }
    }
`;

function graphql(query, variables = {}) {
    return fetch(
        process.env.NODE_ENV === "production"
            ? "https://www.tempiodelfuturo.art/admin/api"
            : "http://localhost:3000/admin/api",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                variables,
                query,
            }),
        }
    ).then(function (result) {
        return result.json();
    });
}
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import MembershipCard from "~/components/app/MembershipCard";
import NextUpEvents from "~/components/app/NextUpEvents.vue";
import AuthedPwChange from "~/components/app/AuthedPwChange.vue";
import DeleteAccountCard from "~/components/app/DeleteAccountCard.vue";
import GridBox from "~/components/GridBox";
import GridItem from "~/components/GridItem";
import GridBody from "~/components/GridBody";
import * as Cookies from "js-cookie";

export default {
    name: "ManageAccount",
    data() {
        return {
            showDeleteModal: false,
            pageTitle: "TDF*P — " + this.$t("manageAccount.meta.title"),
            tesseratiEventi: 0,
            tesseratiCorsi: 0,
            upcomingEvents: [],
            loggedUser: {},
        };
    },
    components: {
        MembershipCard,
        NextUpEvents,
        AuthedPwChange,
        DeleteAccountCard,
        GridBox,
        GridItem,
        GridBody,
        ValidationProvider,
        ValidationObserver,
    },
    layout: "default",
    mounted() {
        this.$store.commit("setCurrPageTitle", this.$t("manageAccount.header"));

        if (this.$store.getters["public-auth/authedUser"].id) {
            this.enterAnimation();
            this.$fetch();
        } else {
            this.$router.push(this.localePath("/u/login"));
        }
    },
    watch: {
        $route(to, from) {
            this.$store.commit(
                "setCurrPageTitle",
                this.$t("manageAccount.header")
            );
        },
    },
    head() {
        return {
            title: this.pageTitle,
        };
    },
    async fetch() {
        const { data } = await graphql(CHECK_USER);

        // const { data: events } = await graphql(UPCOMING_EVENTS, {
        //     startgte: new Date().toISOString(),
        //     endlte: new Date(
        //         new Date().setDate(new Date().getDate() + 7)
        //     ).toISOString(),
        // });

        // if (events.allEventi) {
        //     this.upcomingEvents = events.allEventi;
        // }

        if (data && data.authenticatedPublicUtente) {
            if (data.authenticatedPublicUtente.active) {
                this.loggedUser = data.authenticatedPublicUtente;
                this.$store.commit(
                    "public-auth/SET_USER",
                    {
                        id: data.authenticatedPublicUtente.id,
                        email: data.authenticatedPublicUtente.email,
                        firstName: data.authenticatedPublicUtente.firstName,
                        lastName: data.authenticatedPublicUtente.lastName,
                    }
                    // { root: true }
                );
            } else {
                this.$store.dispatch("setLoggedIn", false);
                this.$router.push(this.localePath("/u/confirm/trigger"));
            }
            // console.log("STORE", this.$store.state["public-auth"]);
        } else {
            this.$store.dispatch("setLoggedIn", false);
            this.$router.push(this.localePath("/u/login"));
        }
    },
    methods: {
        async authLogout() {
            try {
                console.log(
                    "browser base url: " + process.env.BROWSER_BASE_URL
                );
                const isDev = process.env.NODE_ENV !== "production";

                await this.$store.dispatch("public-auth/logout");

                if (
                    this.$cookies &&
                    this.$cookies.get("authrefToken") &&
                    this.$cookies.get("authrefToken").length > 0
                ) {
                    Cookies.remove("authrefToken", {
                        path: "/",
                        domain: isDev
                            ? "localhost"
                            : process.env.BROWSER_BASE_URL,
                    });
                }

                this.$router.push(this.localePath("/u/login"));
            } catch (e) {
                console.error(e);
            } finally {
            }
        },
        enterAnimation() {
            const anime = this.$anime;
            anime({
                targets: ".main-content",
                easing: "easeInOutQuad",
                opacity: [0, 1],
                filter: ["blur(2rem)", "blur(0px)"],
                duration: 360,
            });
        },
    },
    // beforeMount() {
    //   window.addEventListener("scroll", this.handleScroll);
    // },
    // beforeDestroy() {
    //   window.removeEventListener("scroll", this.handleScroll);
    // },
};

// var position = 0;

// window.scroll(function () {
//   position++;
//   position = position + 2;
//   var move = "translateX(" + position + "px)";
//   $(".hc-map").css({ "-moz-transform": move, "-webkit-transform": move });
// });
</script>
